import { DeleteOutlined } from "@ant-design/icons";
import { SettingsCard } from "admin/account/helpers/settings_card";
import { SettingsTitle } from "admin/account/helpers/settings_title";
import { deleteOrganization } from "admin/api/organization";
import { App, Button, Typography, theme } from "antd";
import { useState } from "react";
import { ModalWidth } from "theme";
import { useActiveOrganization, useCanManageOrganization } from "./organization_hooks";

export function OrganizationDangerZoneView() {
  const organization = useActiveOrganization();
  const canManageOrganization = useCanManageOrganization();
  const [isDeleting, setIsDeleting] = useState(false);
  const { modal } = App.useApp();
  const { token } = theme.useToken();

  async function handleDeleteButtonClicked(): Promise<void> {
    const isDeleteConfirmed = await modal.confirm({
      title: "Danger Zone",
      width: ModalWidth.Medium,
      content: (
        <div>
          <Typography.Title level={4} type="danger">
            You will lose access to all the datasets and annotations uploaded/created as part of
            this organization!
          </Typography.Title>
          <Typography.Title level={4} type="danger">
            Unless you are part of another WEBKNOSSOS organization, you can NOT login again with
            this account and will lose access to WEBKNOSSOS.
          </Typography.Title>
          <p>
            Deleting an organization{" "}
            <Typography.Text type="danger">cannot be undone</Typography.Text>. Are you certain you
            want to delete the organization {organization.name}?
          </p>
        </div>
      ),
      okText: <>Yes, delete this organization now and log me out.</>,
      okType: "danger",
    });

    if (isDeleteConfirmed) {
      setIsDeleting(true);
      await deleteOrganization(organization.id);
      setIsDeleting(false);
      window.location.replace(`${window.location.origin}`);
    }
  }
  return (
    <>
      <SettingsTitle
        title="Delete Organization"
        description="Delete this organization including all annotations, uploaded datasets, and associated
            user accounts. Careful, this action can NOT be undone."
      />
      <SettingsCard
        title="Danger Zone"
        style={{ height: "auto" }}
        icon={<DeleteOutlined style={{ color: token.colorError }} />}
        content={`Delete ${organization.name}`}
        hint="Removes all annotations, datasets and user accounts. This cannot be undone."
        footerAction={
          canManageOrganization ? (
            <Button danger loading={isDeleting} onClick={handleDeleteButtonClicked}>
              Delete Organization
            </Button>
          ) : null
        }
      />
    </>
  );
}
